module.exports = __webpack_public_path__ + "img/3.24a1021b.png";